export default __webpack_public_path__ + "static/soehne-web-leicht-kursiv-9dc771a1a998324806072738f33cae8f.woff";